import React, { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import { Plus, Trash2 } from "lucide-react";
import FileInputField from "../../components/form/FileInputField";
import { useDispatch, useSelector } from "react-redux";
import { getUUID } from "../../util";
import { changeFileName } from "../../util/file";
import { addProjectExpenses } from "../../features/projectsSlice";
import { useNotification } from "../../components/notification/NotificationContainer";
import { closeModal } from "../../features/modalSLice";
import { getAccountCategory } from "../../features/accountsSlice";
import { getCurrencies } from "../../features/currenciesSlice";
import { getMethodTypes } from "../../features/transactionsSlice";
import SelectField from "../../components/form/SelectField";

const AddTaskExpense = () => {
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const project = useSelector((state) => state.projects.selected);
  const methodTypes = useSelector((state) => state.transactions.methodTypes);
  const currencies = useSelector((state) => state.currencies.data);
  const category = useSelector(
    (state) => state.accounts.selectedAccountCategory
  );
  const addExpenseLoad = useSelector(
    (state) => state.projects.load.addProjectExpenses
  );
  const {
    handleSubmit,
    register,
    setValue,
    control,
    watch,
    formState: { errors },
  } = useForm({
    project_id: project.id,
    account_id: project.account.id,
  });
  const { append, remove, fields } = useFieldArray({
    control,
    name: "expenses",
  });

  const onSubmit = async (data) => {
    try {
      const dataTransfer = new DataTransfer();

      data.expenses.map((item) => {
        if (item.doc && item.doc.length > 0) {
          dataTransfer.items.add(changeFileName(item.doc[0], item.id));
        }
      });

      const newData = {
        project_id: data.project_id,
        expense_id: data.expense_id,
        account_id: data.account_id,
        currency_id: data.currency_id,
        method_id: data.method_id,
        document: data.document.length > 0 ? data.document[0] : null,
        expenses: data.expenses.map((item) => {
          return {
            amount: item.amount,
            account_id: data.account_id,
            sub_category_id: item.sub_category_id,
            name: item.item,
            naration: item.naration,
            id: item.id,
          };
        }),
        documents: dataTransfer.files,
      };

      //Upload the items
      const res = await dispatch(
        addProjectExpenses({ id: data.project_id, data: newData })
      );
      if (addProjectExpenses.fulfilled.match(res)) {
        dispatch(closeModal());
        addNotification("Expenses added Successfully", "success");
      } else {
        addNotification(res.payload.message, "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  useEffect(() => {
    dispatch(getCurrencies());
    dispatch(getMethodTypes());
  }, []);

  useEffect(() => {
    setValue("project_id", project.id);
    setValue("account_id", project.account?.id);
    setValue("expense_id", project.expense_id);
  }, [project]);

  useEffect(() => {
    if (project.id && project.account.category_id) {
      dispatch(getAccountCategory(project.account.category_id));
    }
  }, [project]);

  console.log(project);

  return (
    <div className="min-w-52 sm:min-w-[35rem] lg:min-w-[50rem] sm:max-w-2xl max-w-[21rem] w-full text-text-1/80">
      <div className="flex flex-col justify-center items-center gap-2 py-5 border-b border-bkg2 mb-4 ">
        <h4>Expense Tracking </h4>
      </div>
      <form
        onSubmit={handleSubmit(onSubmit)}
        method="post"
        encType="multipart/form-data"
      >
        <div className=" justify-between items-center py-4">
          <p>
            Date: <span>{new Date().toDateString()}</span>
          </p>
          <p>
            Account:
            <span className="text-text-1/90">
              {project.account.name || "N/A"}
            </span>
          </p>
          <p>
            Account Category:
            <span className="text-text-1/90">{category.name || "N/A"}</span>
          </p>
        </div>

        {/* Select  */}
        <div>
          <SelectField
            name="method_id"
            register={register}
            label="Method Type"
            errors={errors.method_id}
            data={[{ id: "", name: "-- Select Method Type" }, ...methodTypes]}
          />
          <SelectField
            name="currency_id"
            register={register}
            label="Currency"
            errors={errors.currency_id}
            data={[{ id: "", name: "-- Select Method Type" }, ...currencies]}
          />
        </div>

        {/* Table */}
        <div>
          <button
            type="button"
            onClick={(e) =>
              append({
                item: "",
                amount: 0,
                naration: "",
                doc: null,
                id: getUUID(),
              })
            }
          >
            <Plus
              className="text-primary border  p-1 border-primary rounded-md"
              size={20}
            />
          </button>
        </div>
        <div className="table-container !w-full">
          <table className="mb-4">
            <thead className="text-nowrap">
              <tr>
                <th className="p-1 px-2">No</th>
                <th className="p-1 px-2">Item</th>
                <th className="p-1 px-2">Sub Category</th>
                <th className="p-1 px-2">Amount</th>
                <th className="p-1 px-2">Naration</th>
                <th className="p-1 px-2">Doc</th>
                <th className="p-1 px-2">Action</th>
              </tr>
            </thead>

            <tbody>
              {fields.map((item, index) => (
                <tr key={index}>
                  <td className="p-1 px-2">{index + 1}</td>
                  <td className="p-1 px-2">
                    <input
                      type="text"
                      className="w-36 bg-content"
                      {...register(`expenses.[${index}].item`)}
                    />
                  </td>
                  <td className="p-1 px-2">
                    <select
                      type="text"
                      className="w-44 bg-content"
                      {...register(`expenses.[${index}].sub_category_id`)}
                    >
                      <option value={null}>-- Select Sub Category</option>
                      {category.id &&
                        category.subCategories.map((item) => (
                          <option value={item.id} key={item.id}>
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </td>
                  <td className="p-1 px-2">
                    <input
                      type="number"
                      min={0}
                      step={0.1}
                      className="w-24  bg-content"
                      {...register(`expenses.[${index}].amount`)}
                    />
                  </td>
                  <td className="p-1 px-2">
                    <input
                      type="text"
                      className="w-60  bg-content"
                      {...register(`expenses.[${index}].naration`)}
                    />
                  </td>
                  <td className="p-1 px-2">
                    <div className="flex">
                      <input
                        type="file"
                        accept=".pdf, .txt"
                        className="w-40  bg-content"
                        {...register(`expenses.[${index}].doc`)}
                      />
                      {/* <label htmlFor={`expenses.[${index}].doc`}>Select</label> */}
                    </div>
                  </td>
                  <td className="p-1 px-2">
                    <button onClick={(e) => remove(index)}>
                      <Trash2 className="text-red-500" size={20} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <FileInputField
          register={register}
          name="document"
          setValue={setValue}
          label="Documents"
          watch={watch}
          accept=".pdf, application/pdf, image/*"
          maxImages={1}
        />
        <ResourseButtons submitText="Save" loading={addExpenseLoad} />
      </form>
    </div>
  );
};

export default AddTaskExpense;
